<template>
  <Row>
    <Alert type="error" show-icon v-show="showErrorAlert">
      Wrong username or password
      <span slot="desc">
        Either your username or password was wrong, please try again.
      </span>
    </Alert>

    <Card dis-hover>
      <h1 slot="title">Sign in</h1>
      <i-form ref="form" :model="form" :rules="rules">
        <i-form-item prop="username" label="Username">
          <i-input type="text" v-model="form.username" @on-enter="signin" />
        </i-form-item>
        <i-form-item prop="password" label="Password">
          <i-input type="password" v-model="form.password" @on-enter="signin" />
        </i-form-item>
        <i-form-item>
          <i-button type="primary" @click="signin">Login</i-button>
        </i-form-item>
      </i-form>
    </Card>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      showErrorAlert: false,
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: {
          required: true,
          message: "Username is required",
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    signin() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.login(this.form, this.$store)
            .then(() => {
              // this.keepLiveSession()
              this.$router.push("/");
            })
            .catch(() => {
              this.showErrorAlert = true;
            });
        }
      });
    },
  },
};
</script>

<style lang="css"></style>
